export function initNpsSurvey() {
  const survey = document.querySelector('[data-nps-survey]');
  if (!survey) return;

  const dismissed = localStorage.getItem('dcco-nps-dismissed');
  if (dismissed) return;

  setTimeout(() => {
    survey.classList.remove('hidden');
  }, 5000);

  const closeBtn = survey.querySelector('[data-nps-close]');
  const scoreButtons = survey.querySelectorAll('[data-nps-score]');
  const feedbackArea = survey.querySelector('[data-nps-feedback]');
  const thanksArea = survey.querySelector('[data-nps-thanks]');
  const submitBtn = survey.querySelector('[data-nps-submit]');
  const scoreRow = survey.querySelector('[dir="ltr"]');
  const labels = scoreRow ? scoreRow.nextElementSibling : null;

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      survey.classList.add('hidden');
      localStorage.setItem('dcco-nps-dismissed', Date.now());
    });
  }

  scoreButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      scoreButtons.forEach(b => {
        b.classList.remove('border-dcco-secondary', 'bg-dcco-secondary/10', 'text-dcco-secondary', 'border-green-500', 'bg-green-50', 'text-green-600', 'border-red-500', 'bg-red-50', 'text-red-500');
      });
      const score = parseInt(btn.dataset.npsScore);
      if (score >= 9) {
        btn.classList.add('border-dcco-secondary', 'bg-dcco-secondary/10', 'text-dcco-secondary');
      } else if (score >= 7) {
        btn.classList.add('border-green-500', 'bg-green-50', 'text-green-600');
      } else {
        btn.classList.add('border-red-500', 'bg-red-50', 'text-red-500');
      }
      if (feedbackArea) feedbackArea.classList.remove('hidden');
    });
  });

  if (submitBtn) {
    submitBtn.addEventListener('click', () => {
      if (feedbackArea) feedbackArea.classList.add('hidden');
      if (scoreRow) scoreRow.classList.add('hidden');
      if (labels) labels.classList.add('hidden');
      survey.querySelector('p.text-xs').classList.add('hidden');
      if (thanksArea) thanksArea.classList.remove('hidden');
      localStorage.setItem('dcco-nps-dismissed', Date.now());
      setTimeout(() => {
        survey.classList.add('hidden');
      }, 3000);
    });
  }
}
